(window["webpackJsonp"] = window["webpackJsonp"] || []).push([["main"],{

/***/ "./$$_lazy_route_resource lazy recursive":
/*!******************************************************!*\
  !*** ./$$_lazy_route_resource lazy namespace object ***!
  \******************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

function webpackEmptyAsyncContext(req) {
	// Here Promise.resolve().then() is used instead of new Promise() to prevent
	// uncaught exception popping up in devtools
	return Promise.resolve().then(function() {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	});
}
webpackEmptyAsyncContext.keys = function() { return []; };
webpackEmptyAsyncContext.resolve = webpackEmptyAsyncContext;
module.exports = webpackEmptyAsyncContext;
webpackEmptyAsyncContext.id = "./$$_lazy_route_resource lazy recursive";

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html":
/*!**************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html ***!
  \**************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<app-toolbar (onFileSelected)='onFileReceived($event)' (onMultipleFileSelected)='onMultipleFileSelected($event)'></app-toolbar>\n\n<div>\n\n\n    <div *ngIf=\"singleLogViewer\" class=\"container\">\n\n        <div class=\"col\">\n\n            <div class=\"col\" style=\"background-color:rgb(240, 244, 252); height: 100%;\">\n\n\n                <p style=\"padding: 20px;\">\n                    Drag-and-drop your <strong>LogFile file</strong>\n                </p>\n\n                <ng-template [ngIf]=\"fileContent\">\n                    <h2>\n                        Dropped File Content\n                    </h2>\n\n                    <code class=\"file-content\">\n                  <pre>{{ fileContent }}</pre>\n                </code>\n                </ng-template>\n\n                <!--\n                In this exploration, I'm deferring the initiating \"drag\" event to the drop\n                zone itself. By default, it is hidden, but it is listening to the WINDOW for\n                drag events. Then, when the user drags a file over the window, the drop zone\n                will bring itself into full view.\n              -->\n                <my-file-drop (textDrop)=\"renderFileContent( $event )\">\n                    Drop Your File ( like it's hot )\n                </my-file-drop>\n\n            </div>\n\n        </div>\n    </div>\n\n\n    <br>\n\n    <div *ngIf=\"singleLogViewer\" class=\"container\">\n\n        <div class=\"col\">\n\n            <div class=\"row-md-12\">\n\n                <div class=\"col-md-6\">\n                    <mat-card>\n                        <mat-card-header>\n                            <h5 style=\"color: #0b518f; font-size: 18px;\"><b>Application Info</b></h5>\n                        </mat-card-header>\n                        <div class=\"col\">\n\n                            <div style=\"height: 1px;background-color: #e7e6e6;margin-left: 22px;margin-right: 12px;\">\n                            </div>\n                            <ul style=\"font-size:12px\" style=\"margin-top: 12px;margin-left: 18px;\">\n                                <b style=\"color: #337ab7;\"> AppId &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:</b>&nbsp;&nbsp;&nbsp;<b> {{appId}}</b>\n                                <br>\n                                <b style=\"color: #337ab7;\">AppVersion &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:</b>&nbsp;&nbsp;&nbsp; <b>{{appVersion}}</b>\n                                <br>\n                                <b style=\"color: #337ab7;\">Device ID &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:</b>&nbsp; &nbsp;&nbsp;<b>{{deviceId}}</b>\n                                <br>\n                                <b style=\"color: #337ab7;\"> EMROperator &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:</b>&nbsp;&nbsp;&nbsp;<b> {{EMROperator}}</b>\n                                <br>\n                                <b style=\"color: #337ab7;\">MacID &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:</b>&nbsp;&nbsp;&nbsp;<b> {{macId}}</b>\n\n                            </ul>\n                        </div>\n\n                    </mat-card>\n\n\n                </div>\n                <div class=\"col-md-6\">\n\n                    <mat-card>\n\n                        <mat-card-header>\n                            <h4><b>Log Information(Count)</b></h4>\n                        </mat-card-header>\n\n                        <div class=\"col\">\n\n                            <div style=\"height: 1px;background-color: #e7e6e6;margin-left: 22px;margin-right: 12px;\">\n                            </div>\n                            <div class=\"row\" style=\"font-size:12px\" style=\"margin-top: 16px;\">\n                                <div class=\"col-md-6\">\n                                    <span (click)=\"showOnlyINFO()\" class=\"label label-success\" style=\"padding: 8px; font-size: 12px; margin-left: 70px; cursor:pointer\"> <b>INFO\n                      Count&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:&nbsp;</b> {{info}}</span>\n                                    <br>\n                                    <br>\n                                    <span (click)=\"showOnlyWARNING()\" class=\"label label-warning\" style=\"padding: 8px; font-size: 12px; margin-left: 70px; cursor:pointer\"><b>WARNING\n                      Count&nbsp;&nbsp;&nbsp;:&nbsp;</b>\n                    {{warning}}</span>\n                                    <br>\n                                    <br>\n                                    <span (click)=\"showOnlyDEBUG()\" class=\"label label-primary\" style=\"padding: 8px; font-size: 12px; margin-left: 70px; cursor:pointer\"><b>DEBUG\n                      Count&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;:&nbsp;</b> {{debug}}</span>\n                                    <br>\n                                </div>\n\n\n\n                                <div class=\"col-md-6\">\n                                    <span (click)=\"showOnlyERROR()\" class=\"label label-danger\" style=\"padding: 8px; font-size: 12px; cursor:pointer\"><b>ERROR\n                      Count&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; :&nbsp;</b> {{error}}</span>\n                                    <br>\n                                    <br>\n                                    <span class=\"label label-info\" style=\"padding: 8px; font-size: 12px;\"><b>API HIT Count\n                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:&nbsp;</b> {{apihit}}</span>\n                                    <br>\n                                    <br>\n                                    <span (click)=\"showOnlyShowALL()\" class=\"label label-primary\" style=\"padding: 8px; font-size: 12px; cursor:pointer\"><b>Total\n                      Count&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;:&nbsp;</b> {{OrginalLogData.length}}</span>\n                                    <br>\n                                </div>\n                            </div>\n\n\n\n                        </div>\n\n\n                        <div style=\"height: 6px;\">\n\n                        </div>\n\n                    </mat-card>\n\n                </div>\n            </div>\n\n        </div>\n\n    </div>\n\n    <br>\n\n    <div *ngIf=\"false\" class=\"row container\">\n\n        <mat-card style=\"margin-left: 50px;\">\n\n            <mat-card-header>\n                <h4><b>Log Filter</b></h4>\n            </mat-card-header>\n            <div>\n                <!-- <datetime [datepicker]=\"false\" [(ngModel)]=\"timevalue\"></datetime> -->\n\n\n\n            </div>\n\n        </mat-card>\n    </div>\n\n\n    <br>\n\n\n    <div *ngIf=\"LogData.length>0\" class=\"container\">\n\n\n        <div class=\"row\" style='margin:12px'>\n\n            <mat-card>\n\n                <mat-card-header>\n                    <h4>Log List</h4>\n                </mat-card-header>\n                <hr>\n                <div class=\"table-responsive\">\n                    <table class=\"table table-bordered\">\n                        <thead>\n                            <tr>\n                                <th class=\"fitwidth\">S.No</th>\n                                <th class=\"fitwidth\">Date</th>\n                                <th class=\"fitwidth\">Time</th>\n                                <th class=\"fitwidth\">LogLevel</th>\n                                <th class=\"fitwidth\">UserID</th>\n                                <th class=\"fitwidth\">FacilityId</th>\n                                <th class=\"fitwidth\">Action</th>\n                                <th>Message</th>\n                            </tr>\n                        </thead>\n                        <tbody>\n                            <tr *ngFor=\"let singleLog of LogData\">\n                                <td class=\"fitwidth\">{{singleLog.no}}</td>\n                                <td class=\"fitwidth\">{{singleLog.datetime.split('T')[0].replace('-','/').replace('-','/')|date}} </td>\n                                <td class=\"fitwidth\">{{singleLog.time }} </td>\n\n\n                                <td *ngIf=\"singleLog.loglevel==='INFO'\" class=\"fitwidth\"><span class=\"label label-success\">{{singleLog.loglevel}}</span></td>\n                                <td *ngIf=\"singleLog.loglevel==='ERROR'\" class=\"fitwidth\"><span class=\"label label-danger\">{{singleLog.loglevel}}</span></td>\n                                <td *ngIf=\"singleLog.loglevel==='WARNING'\" class=\"fitwidth\"><span class=\"label label-warning\">{{singleLog.loglevel}}</span></td>\n                                <td *ngIf=\"singleLog.loglevel==='DEBUG'\" class=\"fitwidth\"><span class=\"label label-primary\">{{singleLog.loglevel}}</span></td>\n                                <td *ngIf=\"singleLog.loglevel==='NA'\" class=\"fitwidth\"><span class=\"label label-primary\">{{singleLog.loglevel}}</span></td>\n\n\n\n                                <td class=\"fitwidth\" title=\"{{singleLog.userId}}\" style=\"white-space:pre-wrap; word-wrap:break-word\">{{singleLog.userId}}</td>\n                                <td class=\"fitwidth\" title=\"{{singleLog.FacID}}\">{{singleLog.FacID}}</td>\n                                <td class=\"fitwidth\">{{singleLog.action}}</td>\n\n                                <td data-title=\"{{singleLog.message}}\" style=\"white-space:pre-wrap; word-wrap:break-word\">\n                                    <div class=\"scrollable\" style=\"white-space:pre-wrap; word-wrap:break-word\">{{singleLog.message}}\n                                    </div>\n                                </td>\n                                <!-- <td title=\"{{singleLog.message}}\">\n                {{singleLog.message}}\n\n\n</td> -->\n\n                            </tr>\n                        </tbody>\n                    </table>\n                </div>\n            </mat-card>\n\n        </div>\n\n    </div>\n\n\n    <!-- <div class=\"container\"> -->\n    <div style=\"margin: 20px;\">\n\n        <mat-accordion #accordion=\"matAccordion\" [multi]=\"true\">\n            <mat-expansion-panel [expanded]=\"true\" [id]=\"fileReference.name\" (opened)=\"openGroup(fileReference)\" *ngFor=\"let fileReference of selectedFiles;\" style=\"background-color: rgba(0, 0, 0, 0.158);\">\n                <mat-expansion-panel-header style=\"background-color: #0b518f;\">\n                    <mat-panel-title style=\"color: white;\">\n                        {{fileReference.name}}\n                    </mat-panel-title>\n                    <mat-panel-description>\n                        <div class=\"row\">\n                            <span *ngIf=\"false\" class=\"col-md-3\" style=\"padding: 8px; font-size: 12px; margin-left: 70px; cursor:pointer\">\n                                <i class=\"glyphicon glyphicon-refresh spinning\"></i>\n\n                            </span>\n\n                            <span *ngIf=\"false\" class=\"col-md-3\" (click)=\"showOnlyDEBUG()\" class=\"label label-primary\" style=\"padding: 8px; font-size: 12px; margin-left: 70px; cursor:pointer\"><b>T</b> {{countData[fileReference.name].total}}</span>\n                            <span *ngIf=\"false\" class=\"col-md-3\" (click)=\"showOnlyWARNING()\" class=\"label label-warning\" style=\"padding: 8px; font-size: 12px; margin-left: 70px; cursor:pointer\"><b>W</b>\n                                {{countData[fileReference.name].warning}}</span>\n                            <span *ngIf=\"false\" class=\"col-md-3\" (click)=\"showOnlyINFO()\" class=\"label label-danger\" style=\"padding: 8px; font-size: 12px; margin-left: 70px; cursor:pointer\"> <b>E</b> {{countData[fileReference.name].error}}</span>\n\n\n\n                        </div>\n\n                    </mat-panel-description>\n                </mat-expansion-panel-header>\n\n                <div>\n                    <app-logdetail [file]=\"fileReference\" (onCountsReceive)=\"onCountsReceived($event)\">\n\n                    </app-logdetail>\n                </div>\n            </mat-expansion-panel>\n\n\n\n\n        </mat-accordion>\n\n    </div>\n\n\n</div>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/logdetail/logdetail.component.html":
/*!******************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/logdetail/logdetail.component.html ***!
  \******************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"container\">\n    <br>\n    <br>\n    <div class=\"col\">\n\n        <div class=\"row-md-12\">\n\n            <div class=\"col-md-6\">\n                <mat-card>\n                    <mat-card-header>\n                        <h5 style=\"color: #0b518f; font-size: 18px;\"><b>Application Info</b></h5>\n                    </mat-card-header>\n                    <div class=\"col\">\n\n                        <div style=\"height: 1px;background-color: #e7e6e6;margin-left: 6px;margin-right: 12px;\">\n                        </div>\n                        <ul style=\"font-size:12px\" style=\"margin-top: 12px;margin-left: 18px;\">\n                            <b style=\"color: #337ab7;\"> AppId &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:</b>&nbsp;&nbsp;&nbsp;<b> {{appId}}</b>\n                            <br>\n                            <b style=\"color: #337ab7;\">AppVersion &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:</b>&nbsp;&nbsp;&nbsp; <b>{{appVersion}}</b>\n                            <br>\n                            <b style=\"color: #337ab7;\">Device ID &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:</b>&nbsp; &nbsp;&nbsp;<b>{{deviceId}}</b>\n                            <br>\n                            <b style=\"color: #337ab7;\"> EMROperator &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:</b>&nbsp;&nbsp;&nbsp;<b> {{EMROperator}}</b>\n                            <br>\n                            <b style=\"color: #337ab7;\">MacID &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:</b>&nbsp;&nbsp;&nbsp;<b> {{macId}}</b>\n\n                        </ul>\n                    </div>\n\n                </mat-card>\n\n\n            </div>\n            <div class=\"col-md-6\">\n\n                <mat-card>\n\n                    <mat-card-header>\n                        <div class=\"row-md-12\" style=\"width: -webkit-fill-available;\">\n\n                            <div class=\"col-md-8\">\n                                <h4><b>Log Information(Count)</b></h4>\n                            </div>\n\n                            <div class=\"col-md-4\">\n\n                                <div class=\"btn btn-primary\" (click)=\"showAllLogFiles()\" *ngIf=\"showAllLogs\">Hide Logs</div>\n\n                                <div class=\"btn btn-primary\" (click)=\"showAllLogFiles()\" *ngIf=\"!showAllLogs\">Show Logs</div>\n\n                            </div>\n                        </div>\n\n                    </mat-card-header>\n\n                    <div class=\"col\">\n\n                        <div style=\"height: 1px;background-color: #e7e6e6;margin-left: 12px;margin-right: 12px;\">\n                        </div>\n                        <div class=\"row\" style=\"font-size:12px\" style=\"margin-top: 16px;\">\n                            <div class=\"col-md-6\">\n                                <span (click)=\"showOnlyINFO()\" class=\"label label-success\" style=\"padding: 8px; font-size: 12px; margin-left: 70px; cursor:pointer\"> <b>INFO\n                  Count&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:&nbsp;</b> {{info}}</span>\n                                <br>\n                                <br>\n                                <span (click)=\"showOnlyWARNING()\" class=\"label label-warning\" style=\"padding: 8px; font-size: 12px; margin-left: 70px; cursor:pointer\"><b>WARNING\n                  Count&nbsp;&nbsp;&nbsp;:&nbsp;</b>\n                {{warning}}</span>\n                                <br>\n                                <br>\n                                <span (click)=\"showOnlyDEBUG()\" class=\"label label-primary\" style=\"padding: 8px; font-size: 12px; margin-left: 70px; cursor:pointer\"><b>DEBUG\n                  Count&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;:&nbsp;</b> {{debug}}</span>\n                                <br>\n                            </div>\n\n\n\n                            <div class=\"col-md-6\">\n                                <span (click)=\"showOnlyERROR()\" class=\"label label-danger\" style=\"padding: 8px; font-size: 12px; cursor:pointer\"><b>ERROR\n                  Count&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; :&nbsp;</b> {{error}}</span>\n                                <br>\n                                <br>\n                                <span class=\"label label-info\" style=\"padding: 8px; font-size: 12px;\"><b>API HIT Count\n                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:&nbsp;</b> {{apihit}}</span>\n                                <br>\n                                <br>\n                                <span (click)=\"showOnlyShowALL()\" class=\"label label-primary\" style=\"padding: 8px; font-size: 12px; cursor:pointer\"><b>Total\n                  Count&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;:&nbsp;</b> {{OrginalLogData.length}}</span>\n                                <br>\n                            </div>\n                        </div>\n\n\n\n                    </div>\n\n\n                    <div style=\"height: 6px;\">\n\n                    </div>\n\n                </mat-card>\n\n            </div>\n        </div>\n\n    </div>\n\n</div>\n\n<br>\n<div>\n\n\n    <!-- <div *ngIf=\"LogData.length>0\"> -->\n    <div *ngIf=\"showAllLogs\">\n\n\n        <div class=\"row\" style='margin:4px'>\n\n            <mat-card>\n\n                <mat-card-header>\n                    <h4>Log List</h4>\n                </mat-card-header>\n                <hr>\n                <div class=\"table-responsive\">\n                    <table class=\"table table-bordered\">\n                        <thead>\n                            <tr>\n                                <th class=\"fitwidth\">S.No</th>\n                                <th class=\"fitwidth\">Date</th>\n                                <th class=\"fitwidth\">Time</th>\n                                <th class=\"fitwidth\">LogLevel</th>\n                                <th class=\"fitwidth\">UserID</th>\n                                <th class=\"fitwidth\">FacilityId</th>\n                                <th class=\"fitwidth\">Action</th>\n                                <th>Message</th>\n                            </tr>\n                        </thead>\n                        <tbody>\n                            <tr *ngFor=\"let singleLog of LogData\">\n                                <td class=\"fitwidth\">{{singleLog.no}}</td>\n                                <td class=\"fitwidth\">{{singleLog.datetime.split('T')[0].replace('-','/').replace('-','/')|date}} </td>\n                                <td class=\"fitwidth\">{{singleLog.time }} </td>\n\n\n                                <td *ngIf=\"singleLog.loglevel==='INFO'\" class=\"fitwidth\"><span class=\"label label-success\">{{singleLog.loglevel}}</span></td>\n                                <td *ngIf=\"singleLog.loglevel==='ERROR'\" class=\"fitwidth\"><span class=\"label label-danger\">{{singleLog.loglevel}}</span></td>\n                                <td *ngIf=\"singleLog.loglevel==='WARNING'\" class=\"fitwidth\"><span class=\"label label-warning\">{{singleLog.loglevel}}</span></td>\n                                <td *ngIf=\"singleLog.loglevel==='DEBUG'\" class=\"fitwidth\"><span class=\"label label-primary\">{{singleLog.loglevel}}</span></td>\n                                <td *ngIf=\"singleLog.loglevel==='NA'\" class=\"fitwidth\"><span class=\"label label-primary\">{{singleLog.loglevel}}</span></td>\n\n\n\n                                <td class=\"fitwidth\" title=\"{{singleLog.userId}}\" style=\"white-space:pre-wrap; word-wrap:break-word\">{{singleLog.userId}}</td>\n                                <td class=\"fitwidth\" title=\"{{singleLog.FacID}}\">{{singleLog.FacID}}</td>\n                                <td class=\"fitwidth\">{{singleLog.action}}</td>\n\n                                <td data-title=\"{{singleLog.message}}\" style=\"white-space:pre-wrap; word-wrap:break-word\">\n                                    <div class=\"scrollable\" style=\"white-space:pre-wrap; word-wrap:break-word\">{{singleLog.message}}\n                                    </div>\n                                </td>\n\n\n                            </tr>\n                        </tbody>\n                    </table>\n                </div>\n            </mat-card>\n\n        </div>\n\n    </div>\n\n</div>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/toolbar/toolbar.component.html":
/*!**************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/toolbar/toolbar.component.html ***!
  \**************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<nav class=\"navbar navbar-default navbar-custom\" style=\"background-color: #0b3b6f;\">\n    <div class=\"container-fluid\">\n        <!-- Brand and toggle get grouped for better mobile display -->\n        <div class=\"navbar-header\">\n            <button type=\"button\" class=\"navbar-toggle collapsed\" data-toggle=\"collapse\" data-target=\"#bs-example-navbar-collapse-1\" aria-expanded=\"false\">\n          <span class=\"sr-only\">Toggle navigation</span>\n          <span class=\"icon-bar\"></span>\n          <span class=\"icon-bar\"></span>\n          <span class=\"icon-bar\"></span>\n        </button>\n            <a class=\"navbar-brand\" href=\"/\" style=\"color: white;\">NurseRosie LogViewer</a>\n        </div>\n\n        <!-- Collect the nav links, forms, and other content for toggling -->\n        <div class=\"collapse navbar-collapse\" id=\"bs-example-navbar-collapse-1\">\n            <ul class=\"nav navbar-nav\">\n\n            </ul>\n            <form class=\"navbar-form navbar-left\">\n                <div class=\"form-group\">\n                    <!-- <input type=\"text\" class=\"form-control\" placeholder=\"Search\"> -->\n                </div>\n            </form>\n            <ul class=\"nav navbar-nav navbar-right\" style=\"align-content: center; align-items: center;\">\n                <li *ngIf=\"singleLogViewer\" style=\"margin-top: 6px; margin-right:20px\"><input type='file' accept=\"text/*\" (change)=\"fileChanged($event)\" class=\"btn btn-primary\" style=\"color: white;\" title=\"Choose Single LogFile\"></li>\n\n                &nbsp;\n                <li style=\"margin-top: 6px;\"> <input type=\"file\" ng-file-model=\"files\" (change)=\"fileChangedMultiple($event)\" multiple class=\"btn btn-primary\" style=\"color: white;\" title=\"Choose Multiple LogFiles\" /></li>\n\n            </ul>\n        </div>\n        <!-- /.navbar-collapse -->\n    </div>\n    <!-- /.container-fluid -->\n</nav>");

/***/ }),

/***/ "./node_modules/tslib/tslib.es6.js":
/*!*****************************************!*\
  !*** ./node_modules/tslib/tslib.es6.js ***!
  \*****************************************/
/*! exports provided: __extends, __assign, __rest, __decorate, __param, __metadata, __awaiter, __generator, __exportStar, __values, __read, __spread, __spreadArrays, __await, __asyncGenerator, __asyncDelegator, __asyncValues, __makeTemplateObject, __importStar, __importDefault */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__extends", function() { return __extends; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__assign", function() { return __assign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__rest", function() { return __rest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__decorate", function() { return __decorate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__param", function() { return __param; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__metadata", function() { return __metadata; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__awaiter", function() { return __awaiter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__generator", function() { return __generator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__exportStar", function() { return __exportStar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__values", function() { return __values; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__read", function() { return __read; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__spread", function() { return __spread; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__spreadArrays", function() { return __spreadArrays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__await", function() { return __await; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncGenerator", function() { return __asyncGenerator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncDelegator", function() { return __asyncDelegator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncValues", function() { return __asyncValues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__makeTemplateObject", function() { return __makeTemplateObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__importStar", function() { return __importStar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__importDefault", function() { return __importDefault; });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __exportStar(m, exports) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}


/***/ }),

/***/ "./src/app/app-routing.module.ts":
/*!***************************************!*\
  !*** ./src/app/app-routing.module.ts ***!
  \***************************************/
/*! exports provided: AppRoutingModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppRoutingModule", function() { return AppRoutingModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");



const routes = [];
let AppRoutingModule = class AppRoutingModule {
};
AppRoutingModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["NgModule"])({
        imports: [_angular_router__WEBPACK_IMPORTED_MODULE_2__["RouterModule"].forRoot(routes)],
        exports: [_angular_router__WEBPACK_IMPORTED_MODULE_2__["RouterModule"]]
    })
], AppRoutingModule);



/***/ }),

/***/ "./src/app/app.component.scss":
/*!************************************!*\
  !*** ./src/app/app.component.scss ***!
  \************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("th.mat-sort-header-sorted {\n  color: black;\n}\n\n/* Modify the backgorund color */\n\n.navbar-custom {\n  background-color: #073488;\n}\n\ntable {\n  width: 100%;\n}\n\ntd {\n  max-width: 100px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-size: 16px;\n}\n\ntd.last {\n  width: 1px;\n  white-space: nowrap;\n}\n\ntd.fitwidth {\n  width: 1px;\n  white-space: nowrap;\n}\n\n.mat-form-field + .mat-form-field {\n  margin-left: 8px;\n}\n\n/* Tooltip text */\n\n.tooltip .tooltiptext {\n  visibility: hidden;\n  width: 120px;\n  background-color: black;\n  color: #fff;\n  text-align: center;\n  padding: 5px 0;\n  border-radius: 6px;\n  /* Position the tooltip text - see examples below! */\n  position: absolute;\n  z-index: 1;\n}\n\n/* Show the tooltip text when you mouse over the tooltip container */\n\n.tooltip:hover .tooltiptext {\n  visibility: visible;\n}\n\na.tooltip {\n  outline: none;\n}\n\na.tooltip strong {\n  line-height: 30px;\n}\n\na.tooltip:hover {\n  text-decoration: none;\n}\n\na.tooltip span {\n  z-index: 10;\n  display: none;\n  padding: 14px 20px;\n  margin-top: -30px;\n  margin-left: 0px;\n  width: 300px;\n  line-height: 16px;\n}\n\na.tooltip:hover span {\n  display: inline;\n  position: absolute;\n  color: #111;\n  border: 1px solid #DCA;\n  background: #fffAF0;\n}\n\n.callout {\n  z-index: 20;\n  position: absolute;\n  top: 30px;\n  border: 0;\n  left: -12px;\n}\n\n/*CSS3 extras*/\n\na.tooltip span {\n  border-radius: 4px;\n  box-shadow: 5px 5px 8px #CCC;\n}\n\ntr .spnTooltip {\n  z-index: 10;\n  display: none;\n  padding: 14px 20px;\n  margin-top: -30px;\n  margin-left: 8px;\n  width: 300px;\n  line-height: 16px;\n}\n\ntr:hover .spnTooltip {\n  display: inline;\n  position: absolute;\n  color: #111;\n  border: 1px solid #DCA;\n  background: #fffAF0;\n}\n\n.callout {\n  z-index: 20;\n  position: absolute;\n  top: 30px;\n  border: 0;\n  left: -12px;\n}\n\n/* Popup container - can be anything you want */\n\n.popup {\n  position: relative;\n  display: inline-block;\n  cursor: pointer;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\n/* The actual popup */\n\n.popup .popuptext {\n  visibility: hidden;\n  width: 160px;\n  background-color: #555;\n  color: #fff;\n  text-align: center;\n  border-radius: 6px;\n  padding: 8px 0;\n  position: absolute;\n  z-index: 1;\n  bottom: 125%;\n  left: 50%;\n  margin-left: -80px;\n}\n\n/* Popup arrow */\n\n.popup .popuptext::after {\n  content: \"\";\n  position: absolute;\n  top: 100%;\n  left: 50%;\n  margin-left: -5px;\n  border-width: 5px;\n  border-style: solid;\n  border-color: #555 transparent transparent transparent;\n}\n\n/* Toggle this class - hide and show the popup */\n\n.popup .show {\n  visibility: visible;\n  -webkit-animation: fadeIn 1s;\n  animation: fadeIn 1s;\n}\n\n/* Add animation (fade in the popup) */\n\n@-webkit-keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n[data-title]:hover:after {\n  opacity: 1;\n  transition: all 0.1s ease 0.5s;\n  visibility: visible;\n}\n\n[data-title]:after {\n  content: attr(data-title);\n  position: absolute;\n  bottom: -1.6em;\n  left: 100%;\n  padding: 4px 4px 4px 8px;\n  color: #222;\n  white-space: nowrap;\n  border-radius: 5px;\n  box-shadow: 0px 0px 4px #222;\n  background-image: -o-linear-gradient(top, #f8f8f8, #cccccc);\n  opacity: 0;\n  z-index: 99999;\n  visibility: hidden;\n}\n\n[data-title] {\n  position: relative;\n}\n\nth {\n  font-size: 12px;\n}\n\ntd {\n  font-size: 11px;\n}\n/*# sourceMappingURL=data:application/json;base64,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 */");

/***/ }),

/***/ "./src/app/app.component.ts":
/*!**********************************!*\
  !*** ./src/app/app.component.ts ***!
  \**********************************/
/*! exports provided: AppComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppComponent", function() { return AppComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_material_sort__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/material/sort */ "./node_modules/@angular/material/esm2015/sort.js");
/* harmony import */ var _angular_material_table__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/material/table */ "./node_modules/@angular/material/esm2015/table.js");




const ELEMENT_DATA = [
    { position: 1, name: 'Hydrogen', weight: 1.0079, symbol: 'H' },
    { position: 2, name: 'Helium', weight: 4.0026, symbol: 'He' },
    { position: 3, name: 'Lithium', weight: 6.941, symbol: 'Li' },
    { position: 4, name: 'Beryllium', weight: 9.0122, symbol: 'Be' },
    { position: 5, name: 'Boron', weight: 10.811, symbol: 'B' },
    { position: 6, name: 'Carbon', weight: 12.0107, symbol: 'C' },
    { position: 7, name: 'Nitrogen', weight: 14.0067, symbol: 'N' },
    { position: 8, name: 'Oxygen', weight: 15.9994, symbol: 'O' },
    { position: 9, name: 'Fluorine', weight: 18.9984, symbol: 'F' },
    { position: 10, name: 'Neon', weight: 20.1797, symbol: 'Ne' },
];
let AppComponent = class AppComponent {
    // I initialize the app component.
    constructor() {
        this.displayedColumns = ['Time', 'LogLevel', 'UserId', 'FacilityID', 'Action', 'Message'];
        this.dataSource = new _angular_material_table__WEBPACK_IMPORTED_MODULE_3__["MatTableDataSource"](ELEMENT_DATA);
        this.singleLogViewer = false;
        this.macId = "NA";
        this.deviceId = "NA";
        this.appVersion = "NA";
        this.appId = "NA";
        this.EMROperator = "NA";
        this.panelOpenState = false;
        this.countData = {};
        this.fileContent = "";
        this.LogData = [];
        this.OrginalLogData = [];
        this.info = 0;
        this.warning = 0;
        this.debug = 0;
        this.error = 0;
        this.apihit = 0;
    }
    ngOnInit() {
        this.dataSource.sort = this.sort;
    }
    // ---
    // PUBLIC METHODS.
    // ---
    // I get called whenever change detection is triggered on this component.
    // --
    // NOTE: We are logging this in order to make sure that the MASSIVE NUMBER of drag
    // and drop events are not triggering unnecessary change-detection in the app.
    ngDoCheck() {
        console.log("App component ngDoCheck()");
    }
    openGroup(fileReceived) {
        console.log(fileReceived);
    }
    onFileReceived(value) {
        this.renderFileContent(value.toString());
    }
    onMultipleFileSelected(files) {
        console.clear();
        console.log('Multiple Selected Files');
        console.log(files);
        this.selectedFiles = files;
    }
    // When the user drops a text-file on the file-drop component, it will emit the
    // file-content as an event. I render the emitted file-content to the view.
    renderFileContent(value) {
        //this.fileContent = value;
        console.log('fileValues');
        var arrayList = value.split('\n');
        var position = 1;
        arrayList.forEach(log => {
            // 2019-11-22T03:17:49-42:42 LogLevel="DEBUG"
            // macId="b4:ce:f6:9d:fb:c2" deviceId="c21b18248ad66be7"
            //appVersion="8.00.05" appId="RC2.0" userId="NA"
            // EMROperator="NA" FacID="NA" action="GET" message="Login Page Token Receiving"
            var datetime = log.substring(0, 25);
            var loglevel = this.getLogValue(log, "LogLevel", "macId");
            if (this.equalIgnorecase(loglevel, "DEBUG")) {
                this.debug++;
            }
            else if (this.equalIgnorecase(loglevel, "INFO")) {
                this.info++;
            }
            else if (this.equalIgnorecase(loglevel, "ERROR")) {
                this.error++;
            }
            else if (this.equalIgnorecase(loglevel, "WARNING")) {
                this.warning++;
            }
            var macId = this.getLogValue(log, "macId", "deviceId");
            var deviceId = this.getLogValue(log, "deviceId", "appVersion");
            var appVersion = this.getLogValue(log, "appVersion", "appId");
            var appId = this.getLogValue(log, "appId", "userId");
            var EMROperator = this.getLogValue(log, "EMROperator", "FacID");
            if (macId !== undefined || macId !== null) {
                this.macId = macId;
            }
            if (deviceId !== undefined || deviceId !== null) {
                this.deviceId = deviceId;
            }
            if (appVersion !== undefined || appVersion !== null) {
                this.appVersion = appVersion;
            }
            if (appId !== undefined || appId !== null) {
                this.appId = appId;
            }
            if (deviceId !== undefined || deviceId !== null) {
                this.EMROperator = EMROperator;
            }
            var userId = this.getLogValue(log, "userId", "EMROperator").toString();
            var FacID = this.getLogValue(log, "FacID", "action");
            var action = this.getLogValue(log, "action", "message");
            if (this.equalIgnorecase(action, "API URL")) {
                this.apihit++;
            }
            var message = log.substring(log.indexOf("message=\"") + 9, log.length - 1);
            console.log(userId);
            var timevalue = datetime.split('T')[1];
            console.log(timevalue);
            if (timevalue != undefined) {
                this.LogData.push({
                    'no': position,
                    'datetime': datetime,
                    'time': timevalue.substring(0, 8),
                    'loglevel': loglevel,
                    'userId': userId,
                    'FacID': FacID,
                    'action': action,
                    'message': message,
                });
                position++;
            }
        });
        this.OrginalLogData = this.LogData;
        console.log(this.LogData.length);
    }
    equalIgnorecase(a, b) {
        return typeof a === 'string' && typeof b === 'string'
            ? a.localeCompare(b, undefined, { sensitivity: 'accent' }) === 0
            : a === b;
    }
    showOnlyINFO() {
        var filterData = [];
        this.OrginalLogData.forEach(log => {
            if (log.loglevel === "INFO") {
                filterData.push(log);
            }
        });
        this.LogData = filterData;
    }
    showOnlyWARNING() {
        var filterData = [];
        this.OrginalLogData.forEach(log => {
            if (log.loglevel === "WARNING") {
                filterData.push(log);
            }
        });
        this.LogData = filterData;
    }
    showOnlyERROR() {
        var filterData = [];
        this.OrginalLogData.forEach(log => {
            if (log.loglevel === "ERROR") {
                filterData.push(log);
            }
        });
        this.LogData = filterData;
    }
    showOnlyDEBUG() {
        var filterData = [];
        this.OrginalLogData.forEach(log => {
            if (log.loglevel === "DEBUG") {
                filterData.push(log);
            }
        });
        this.LogData = filterData;
    }
    showOnlyShowALL() {
        this.LogData = this.OrginalLogData;
    }
    getLogValue(logdata, startColumn, endColumn) {
        var startIndex = logdata.indexOf(startColumn + "=\"") + startColumn.length;
        var endIndex = logdata.indexOf(endColumn + "=\"") - 1;
        if (startIndex === -1 || endIndex === -1) {
            return "NA";
        }
        var loglevel = logdata.substring(startIndex + 2, endIndex - 1).trim();
        return loglevel;
    }
    // When the user clicks on div, open the popup
    myFunction() {
        var popup = document.getElementById("myPopup");
        popup.classList.toggle("show");
    }
    onCountsReceived(counts) {
        console.log('Counts Received');
        console.log(counts);
        this.countData = counts;
        this.countData[counts.name] = {
            warning: String(counts.warning),
            error: String(counts.error),
            total: String(counts.total),
        };
        console.log('After Data Inserted');
        console.log(this.countData);
    }
};
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewChild"])(_angular_material_sort__WEBPACK_IMPORTED_MODULE_2__["MatSort"], { static: true })
], AppComponent.prototype, "sort", void 0);
AppComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-root',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./app.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./app.component.scss */ "./src/app/app.component.scss")).default]
    })
], AppComponent);



/***/ }),

/***/ "./src/app/app.module.ts":
/*!*******************************!*\
  !*** ./src/app/app.module.ts ***!
  \*******************************/
/*! exports provided: AppModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppModule", function() { return AppModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_platform_browser__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/platform-browser */ "./node_modules/@angular/platform-browser/fesm2015/platform-browser.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _app_routing_module__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./app-routing.module */ "./src/app/app-routing.module.ts");
/* harmony import */ var _app_component__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./app.component */ "./src/app/app.component.ts");
/* harmony import */ var _angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/platform-browser/animations */ "./node_modules/@angular/platform-browser/fesm2015/animations.js");
/* harmony import */ var _angular_material_toolbar__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @angular/material/toolbar */ "./node_modules/@angular/material/esm2015/toolbar.js");
/* harmony import */ var _my_file_drop_my_file_drop_component__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./my-file-drop/my-file-drop.component */ "./src/app/my-file-drop/my-file-drop.component.ts");
/* harmony import */ var _angular_material_table__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @angular/material/table */ "./node_modules/@angular/material/esm2015/table.js");
/* harmony import */ var _toolbar_toolbar_component__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./toolbar/toolbar.component */ "./src/app/toolbar/toolbar.component.ts");
/* harmony import */ var _angular_material_input__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @angular/material/input */ "./node_modules/@angular/material/esm2015/input.js");
/* harmony import */ var _angular_material_button__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @angular/material/button */ "./node_modules/@angular/material/esm2015/button.js");
/* harmony import */ var _angular_material_card__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @angular/material/card */ "./node_modules/@angular/material/esm2015/card.js");
/* harmony import */ var _angular_material_dialog__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! @angular/material/dialog */ "./node_modules/@angular/material/esm2015/dialog.js");
/* harmony import */ var _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! @ng-bootstrap/ng-bootstrap */ "./node_modules/@ng-bootstrap/ng-bootstrap/fesm2015/ng-bootstrap.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var _angular_material_expansion__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! @angular/material/expansion */ "./node_modules/@angular/material/esm2015/expansion.js");
/* harmony import */ var _logdetail_logdetail_component__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ./logdetail/logdetail.component */ "./src/app/logdetail/logdetail.component.ts");


















let AppModule = class AppModule {
};
AppModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["NgModule"])({
        declarations: [
            _app_component__WEBPACK_IMPORTED_MODULE_4__["AppComponent"],
            _my_file_drop_my_file_drop_component__WEBPACK_IMPORTED_MODULE_7__["MyFileDropComponent"],
            _toolbar_toolbar_component__WEBPACK_IMPORTED_MODULE_9__["ToolbarComponent"],
            _logdetail_logdetail_component__WEBPACK_IMPORTED_MODULE_17__["LogdetailComponent"]
        ],
        imports: [
            _angular_platform_browser__WEBPACK_IMPORTED_MODULE_1__["BrowserModule"],
            _app_routing_module__WEBPACK_IMPORTED_MODULE_3__["AppRoutingModule"],
            _angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_5__["BrowserAnimationsModule"],
            _angular_material_toolbar__WEBPACK_IMPORTED_MODULE_6__["MatToolbarModule"],
            _angular_material_table__WEBPACK_IMPORTED_MODULE_8__["MatTableModule"],
            _angular_material_input__WEBPACK_IMPORTED_MODULE_10__["MatInputModule"],
            _angular_material_button__WEBPACK_IMPORTED_MODULE_11__["MatButtonModule"],
            _angular_material_card__WEBPACK_IMPORTED_MODULE_12__["MatCardModule"],
            _angular_material_dialog__WEBPACK_IMPORTED_MODULE_13__["MatDialogModule"],
            _angular_forms__WEBPACK_IMPORTED_MODULE_15__["FormsModule"],
            _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_14__["NgbModule"],
            _angular_material_expansion__WEBPACK_IMPORTED_MODULE_16__["MatExpansionModule"]
        ],
        providers: [],
        bootstrap: [
            _app_component__WEBPACK_IMPORTED_MODULE_4__["AppComponent"]
        ]
    })
], AppModule);



/***/ }),

/***/ "./src/app/logdetail/logdetail.component.scss":
/*!****************************************************!*\
  !*** ./src/app/logdetail/logdetail.component.scss ***!
  \****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2xvZ2RldGFpbC9sb2dkZXRhaWwuY29tcG9uZW50LnNjc3MifQ== */");

/***/ }),

/***/ "./src/app/logdetail/logdetail.component.ts":
/*!**************************************************!*\
  !*** ./src/app/logdetail/logdetail.component.ts ***!
  \**************************************************/
/*! exports provided: LogdetailComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LogdetailComponent", function() { return LogdetailComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_material_sort__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/material/sort */ "./node_modules/@angular/material/esm2015/sort.js");
/* harmony import */ var _angular_material_table__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/material/table */ "./node_modules/@angular/material/esm2015/table.js");




const ELEMENT_DATA = [
    { position: 1, name: 'Hydrogen', weight: 1.0079, symbol: 'H' },
    { position: 2, name: 'Helium', weight: 4.0026, symbol: 'He' },
    { position: 3, name: 'Lithium', weight: 6.941, symbol: 'Li' },
    { position: 4, name: 'Beryllium', weight: 9.0122, symbol: 'Be' },
    { position: 5, name: 'Boron', weight: 10.811, symbol: 'B' },
    { position: 6, name: 'Carbon', weight: 12.0107, symbol: 'C' },
    { position: 7, name: 'Nitrogen', weight: 14.0067, symbol: 'N' },
    { position: 8, name: 'Oxygen', weight: 15.9994, symbol: 'O' },
    { position: 9, name: 'Fluorine', weight: 18.9984, symbol: 'F' },
    { position: 10, name: 'Neon', weight: 20.1797, symbol: 'Ne' },
];
let LogdetailComponent = class LogdetailComponent {
    constructor() {
        this.displayedColumns = ['Time', 'LogLevel', 'UserId', 'FacilityID', 'Action', 'Message'];
        this.dataSource = new _angular_material_table__WEBPACK_IMPORTED_MODULE_3__["MatTableDataSource"](ELEMENT_DATA);
        this.onCountsReceive = new _angular_core__WEBPACK_IMPORTED_MODULE_1__["EventEmitter"]();
        this.macId = "NA";
        this.deviceId = "NA";
        this.appVersion = "NA";
        this.appId = "NA";
        this.EMROperator = "NA";
        this.showAllLogs = false;
        this.fileContent = "";
        this.LogData = [];
        this.OrginalLogData = [];
        this.info = 0;
        this.warning = 0;
        this.debug = 0;
        this.error = 0;
        this.apihit = 0;
    }
    ngOnInit() {
        this.readFile(this.file);
    }
    readFile(file) {
        var reader = new FileReader();
        reader.onload = () => {
            console.log(reader.result);
            this.renderFileContent(reader.result.toString());
        };
        reader.readAsText(file);
    }
    //==========================================================================================
    // When the user drops a text-file on the file-drop component, it will emit the
    // file-content as an event. I render the emitted file-content to the view.
    renderFileContent(value) {
        //this.fileContent = value;
        console.log('fileValues');
        var arrayList = value.split('\n');
        var position = 1;
        arrayList.forEach(log => {
            // 2019-11-22T03:17:49-42:42 LogLevel="DEBUG"
            // macId="b4:ce:f6:9d:fb:c2" deviceId="c21b18248ad66be7"
            //appVersion="8.00.05" appId="RC2.0" userId="NA"
            // EMROperator="NA" FacID="NA" action="GET" message="Login Page Token Receiving"
            var datetime = log.substring(0, 25);
            var loglevel = this.getLogValue(log, "LogLevel", "macId");
            if (this.equalIgnorecase(loglevel, "DEBUG")) {
                this.debug++;
            }
            else if (this.equalIgnorecase(loglevel, "INFO")) {
                this.info++;
            }
            else if (this.equalIgnorecase(loglevel, "ERROR")) {
                this.error++;
            }
            else if (this.equalIgnorecase(loglevel, "WARNING")) {
                this.warning++;
            }
            var macId = this.getLogValue(log, "macId", "deviceId");
            var deviceId = this.getLogValue(log, "deviceId", "appVersion");
            var appVersion = this.getLogValue(log, "appVersion", "appId");
            var appId = this.getLogValue(log, "appId", "userId");
            var EMROperator = this.getLogValue(log, "EMROperator", "FacID");
            if (macId !== undefined || macId !== null) {
                this.macId = macId;
            }
            if (deviceId !== undefined || deviceId !== null) {
                this.deviceId = deviceId;
            }
            if (appVersion !== undefined || appVersion !== null) {
                this.appVersion = appVersion;
            }
            if (appId !== undefined || appId !== null) {
                this.appId = appId;
            }
            if (deviceId !== undefined || deviceId !== null) {
                this.EMROperator = EMROperator;
            }
            var userId = this.getLogValue(log, "userId", "EMROperator").toString();
            var FacID = this.getLogValue(log, "FacID", "action");
            var action = this.getLogValue(log, "action", "message");
            if (this.equalIgnorecase(action, "API URL")) {
                this.apihit++;
            }
            var message = log.substring(log.indexOf("message=\"") + 9, log.length - 1);
            // console.log(userId);
            var timevalue = datetime.split('T')[1];
            //console.log(timevalue);
            if (timevalue != undefined) {
                this.LogData.push({
                    'no': position,
                    'datetime': datetime,
                    'time': timevalue.substring(0, 8),
                    'loglevel': loglevel,
                    'userId': userId,
                    'FacID': FacID,
                    'action': action,
                    'message': message,
                });
                position++;
            }
        });
        this.OrginalLogData = this.LogData;
        console.log(this.LogData.length);
        var countsData = {
            warning: String(this.warning),
            error: String(this.error),
            total: String(this.OrginalLogData.length),
            name: this.file.name
        };
        this.onCountsReceive.emit(countsData);
    }
    equalIgnorecase(a, b) {
        return typeof a === 'string' && typeof b === 'string'
            ? a.localeCompare(b, undefined, { sensitivity: 'accent' }) === 0
            : a === b;
    }
    showOnlyINFO() {
        this.showAllLogs = true;
        var filterData = [];
        this.OrginalLogData.forEach(log => {
            if (log.loglevel === "INFO") {
                filterData.push(log);
            }
        });
        this.LogData = filterData;
    }
    showOnlyWARNING() {
        this.showAllLogs = true;
        var filterData = [];
        this.OrginalLogData.forEach(log => {
            if (log.loglevel === "WARNING") {
                filterData.push(log);
            }
        });
        this.LogData = filterData;
    }
    showOnlyERROR() {
        this.showAllLogs = true;
        var filterData = [];
        this.OrginalLogData.forEach(log => {
            if (log.loglevel === "ERROR") {
                filterData.push(log);
            }
        });
        this.LogData = filterData;
    }
    showOnlyDEBUG() {
        this.showAllLogs = true;
        var filterData = [];
        this.OrginalLogData.forEach(log => {
            if (log.loglevel === "DEBUG") {
                filterData.push(log);
            }
        });
        this.LogData = filterData;
    }
    showOnlyShowALL() {
        this.showAllLogs = true;
        this.LogData = this.OrginalLogData;
    }
    getLogValue(logdata, startColumn, endColumn) {
        var startIndex = logdata.indexOf(startColumn + "=\"") + startColumn.length;
        var endIndex = logdata.indexOf(endColumn + "=\"") - 1;
        if (startIndex === -1 || endIndex === -1) {
            return "NA";
        }
        var loglevel = logdata.substring(startIndex + 2, endIndex - 1).trim();
        return loglevel;
    }
    showAllLogFiles() {
        this.showAllLogs = !this.showAllLogs;
    }
};
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Output"])()
], LogdetailComponent.prototype, "onCountsReceive", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewChild"])(_angular_material_sort__WEBPACK_IMPORTED_MODULE_2__["MatSort"], { static: true })
], LogdetailComponent.prototype, "sort", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])('file')
], LogdetailComponent.prototype, "file", void 0);
LogdetailComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-logdetail',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./logdetail.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/logdetail/logdetail.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./logdetail.component.scss */ "./src/app/logdetail/logdetail.component.scss")).default]
    })
], LogdetailComponent);



/***/ }),

/***/ "./src/app/my-file-drop/my-file-drop.component.css":
/*!*********************************************************!*\
  !*** ./src/app/my-file-drop/my-file-drop.component.css ***!
  \*********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n:host {\n\tbottom: 0px ;\n\tdisplay: none ;\n\tleft: 0px ;\n\tposition: fixed ;\n\tright: 0px ;\n\ttop: 0px ;\n\tz-index: 2 ;\n\n\n}\n:host.active {\n  display: flex ;\n}\n.drag-shield {\n\tbottom: 0px ;\n\tleft: 0px ;\n\tposition: absolute ;\n\tright: 0px ;\n\ttop: 0px ;\n\tz-index: 2 ;\n\n\n}\n.drag-shield.host.active  {\n  border: 6px solid #ff3366 ;\n}\n.call-to-action {\n\tcolor: #ff3366 ;\n\tflex: 0 0 auto ;\n\tfont-family: monospace ;\n\tfont-size: 28px ;\n\tfont-weight: bold ;\n\tmargin: auto auto auto auto ;\n\n\theight: 30px ;\n\tline-height: 30px ;\n}\n\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9hcHAvbXktZmlsZS1kcm9wL215LWZpbGUtZHJvcC5jb21wb25lbnQuY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFDQTtDQUNDLFlBQVk7Q0FDWixjQUFjO0NBQ2QsVUFBVTtDQUNWLGdCQUFnQjtDQUNoQixXQUFXO0NBQ1gsU0FBUztDQUNULFdBQVc7OztBQUdaO0FBQ0E7RUFDRSxjQUFjO0FBQ2hCO0FBQ0E7Q0FDQyxZQUFZO0NBQ1osVUFBVTtDQUNWLG1CQUFtQjtDQUNuQixXQUFXO0NBQ1gsU0FBUztDQUNULFdBQVc7OztBQUdaO0FBQ0E7RUFDRSwwQkFBMEI7QUFDNUI7QUFDQTtDQUNDLGVBQWU7Q0FDZixlQUFlO0NBQ2YsdUJBQXVCO0NBQ3ZCLGdCQUFnQjtDQUNoQixrQkFBa0I7Q0FDbEIsNEJBQTRCOztDQUU1QixhQUFhO0NBQ2Isa0JBQWtCO0FBQ25CIiwiZmlsZSI6InNyYy9hcHAvbXktZmlsZS1kcm9wL215LWZpbGUtZHJvcC5jb21wb25lbnQuY3NzIiwic291cmNlc0NvbnRlbnQiOlsiXG46aG9zdCB7XG5cdGJvdHRvbTogMHB4IDtcblx0ZGlzcGxheTogbm9uZSA7XG5cdGxlZnQ6IDBweCA7XG5cdHBvc2l0aW9uOiBmaXhlZCA7XG5cdHJpZ2h0OiAwcHggO1xuXHR0b3A6IDBweCA7XG5cdHotaW5kZXg6IDIgO1xuXG5cbn1cbjpob3N0LmFjdGl2ZSB7XG4gIGRpc3BsYXk6IGZsZXggO1xufVxuLmRyYWctc2hpZWxkIHtcblx0Ym90dG9tOiAwcHggO1xuXHRsZWZ0OiAwcHggO1xuXHRwb3NpdGlvbjogYWJzb2x1dGUgO1xuXHRyaWdodDogMHB4IDtcblx0dG9wOiAwcHggO1xuXHR6LWluZGV4OiAyIDtcblxuXG59XG4uZHJhZy1zaGllbGQuaG9zdC5hY3RpdmUgIHtcbiAgYm9yZGVyOiA2cHggc29saWQgI2ZmMzM2NiA7XG59XG4uY2FsbC10by1hY3Rpb24ge1xuXHRjb2xvcjogI2ZmMzM2NiA7XG5cdGZsZXg6IDAgMCBhdXRvIDtcblx0Zm9udC1mYW1pbHk6IG1vbm9zcGFjZSA7XG5cdGZvbnQtc2l6ZTogMjhweCA7XG5cdGZvbnQtd2VpZ2h0OiBib2xkIDtcblx0bWFyZ2luOiBhdXRvIGF1dG8gYXV0byBhdXRvIDtcblxuXHRoZWlnaHQ6IDMwcHggO1xuXHRsaW5lLWhlaWdodDogMzBweCA7XG59XG4iXX0= */");

/***/ }),

/***/ "./src/app/my-file-drop/my-file-drop.component.ts":
/*!********************************************************!*\
  !*** ./src/app/my-file-drop/my-file-drop.component.ts ***!
  \********************************************************/
/*! exports provided: MyFileDropComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MyFileDropComponent", function() { return MyFileDropComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");

// Import the core angular services.





let MyFileDropComponent = class MyFileDropComponent {
    // I initialize the file-drop component.
    constructor(dragShieldRef, zone) {
        // ---
        // PUBLIC METHODS.
        // ---
        // I handle the user dragging away from the drop zone / window.
        this.handleShieldDragLeave = (event) => {
            // When the user leaves the drop zone, it means they have left the WINDOW as
            // well. As such, let's close the drop zone and start listening for initiating
            // drag events on the window again.
            // --
            // NOTE: We are still outside of the Angular Zone.
            this.teardownDragShieldEvents();
            this.setupWindowEvents();
            this.zone.run(() => {
                this.isActive = false;
            });
        };
        // I handle the user dragging over the drop zone.
        this.handleShieldDragOver = (event) => {
            // NOTE: This event-handler exists purely to call the .preventDefault() method.
            // Without this call, the browser will attempt to open any file that is dropped
            // on the target.
            event.preventDefault();
        };
        // I handle the user dropping a file on the drop zone.
        this.handleShieldDrop = (event) => {
            // Stop the browser from attempting to open the file.
            event.preventDefault();
            // After the user drops her file, we are going to close the drop zone. As such,
            // we need to start listening for initiating drag events on the window again.
            // --
            // NOTE: We are still outside of the Angular Zone.
            this.teardownDragShieldEvents();
            this.setupWindowEvents();
            this.zone.run(() => {
                this.isActive = false;
                this.emitDroppedFileContent(event);
            });
        };
        // I handle the user dragging a file onto the window (ie, the initiating drag event).
        this.handleWindowDragOver = (event) => {
            // If the event doesn't contain text files, then it isn't a drag event that we
            // are concerned with. Ignore it.
            // --
            // CAUTION: I'm only doing this for the sake of the exploration. Since this isn't
            // something that works well in a CROSS BROWSER way (not all drag events have
            // access to the attached files), we should probably just always show the drop
            // zone and then validate them on drop. But, I'm just trying to learn more about
            // how files work.
            if (!this.shouldRespondToDragEvent(event)) {
                return;
            }
            // NOTE: We don't need to cancel this default behavior because the WINDOW is not
            // the actual drop target - we will cancel this later on in the drop zone.
            // --
            // event.preventDefault();
            // When the user drags a file over the window, we will activate the drop zone.
            // This means we can stop listening for window events and start listening for
            // drop zone events.
            // --
            // NOTE: We are still outside of the Angular Zone.
            this.teardownWindowEvents();
            this.setupDragShieldEvents();
            this.zone.run(() => {
                this.isActive = true;
            });
        };
        this.dragShieldRef = dragShieldRef;
        this.zone = zone;
        this.isActive = false;
        this.textDropEvents = new _angular_core__WEBPACK_IMPORTED_MODULE_1__["EventEmitter"]();
    }
    // I get called once when the component is being destroyed.
    ngDestroy() {
        this.teardownDragShieldEvents();
        this.teardownWindowEvents();
        // CAUTION: I BELIEVE there is a possibility that a FileReader operation is still
        // running as this component is being destroyed. Handling this is a bit outside
        // the scope of this demo; but, if we stored a reference to the FileReader, we
        // could do something like this:
        // --
        // ( this.fileReader ) && this.fileReader.abort();
    }
    // I get called once after the inputs have been bound for the first time.
    ngOnInit() {
        this.setupWindowEvents();
    }
    // ---
    // PRIVATE METHODS.
    // ---
    // I attempt to read the file in the given drop event and emit its content.
    emitDroppedFileContent(event) {
        var file = this.getFileFromDropEvent(event);
        if (!file) {
            return;
        }
        // NOTE: Since Safari and IE can't access the file prior to the DROP event, we
        // have to do one final check of the mime-type before we attempt to read-in the
        // content.
        if (!this.isTextMimeType(file.type)) {
            return;
        }
        var reader = new FileReader();
        // NOTE: At this point (see "drop" event handler), we are BACK INSIDE the Angular
        // Zone. As such, the following event-handlers will automatically be invokes
        // inside the Angular Zone as well.
        reader.onload = () => {
            this.textDropEvents.emit(reader.result);
        };
        reader.onerror = (error) => {
            console.warn('Error reading dropped file:');
            console.error(error);
        };
        reader.onloadend = () => {
            reader = null;
        };
        reader.readAsText(file);
    }
    // I attempt to get the first File in the given drag event. Returns null if a file
    // cannot be found.
    getFileFromDropEvent(event) {
        // "Items" is the most modern interface spec.
        if (event.dataTransfer.items && event.dataTransfer.items.length) {
            for (var item of Array.from(event.dataTransfer.items)) {
                if (item.kind === 'file') {
                    return (item.getAsFile());
                }
            }
            // If the "items" interface was defined, we don't want to fall-back to
            // checking the "files" interface. The "files" interface is legacy and
            // should only be consulted if "items" is unavailable.
            return (null);
        }
        // "Files" is an old interface spec.
        if (event.dataTransfer.files && event.dataTransfer.files.length) {
            return (event.dataTransfer.files[0]);
        }
        return (null);
    }
    // I attempt to get the mime-type of the first file in drag event. Returns null if no
    // file types can be identified.
    // --
    // CAUTION: Not all browsers can access file type meta-data during a DRAG event.
    getFileTypeFromDragEvent(event) {
        // "Items" is the most modern interface spec.
        if (event.dataTransfer.items && event.dataTransfer.items.length) {
            for (var item of Array.from(event.dataTransfer.items)) {
                if (item.kind === 'file') {
                    // CAUTION: DataTransferItem.getAsFile() returns "null" if this is a
                    // "drag" event. I BELIEVE it only returns the file in the "drop"
                    // event. As such, we have to use the "type" on the item itself.
                    return (item.type);
                }
            }
            // If the "items" interface was defined, we don't want to fall-back to
            // checking the "files" interface. The "files" interface is legacy and
            // should only be consulted if "items" is unavailable.
            return (null);
        }
        // "Files" is an old interface spec.
        if (event.dataTransfer.files && event.dataTransfer.files.length) {
            return (event.dataTransfer.files[0].type);
        }
        return (null);
    }
    // I determine if the given mime-type represents a file that contains text content
    // that we can [likely] load into the application.
    isTextMimeType(mimeType) {
        if (mimeType.startsWith('text/')) {
            return (true);
        }
        switch (mimeType) {
            case 'application/json':
            case 'application/x-json':
                return (true);
                break;
            default:
                return (false);
                break;
        }
    }
    // I attach the handlers for the drop zone events.
    setupDragShieldEvents() {
        // NOTE: We are still outside of the Angular Zone.
        this.dragShieldRef.nativeElement.addEventListener('dragover', this.handleShieldDragOver, false);
        this.dragShieldRef.nativeElement.addEventListener('dragleave', this.handleShieldDragLeave, false);
        this.dragShieldRef.nativeElement.addEventListener('drop', this.handleShieldDrop, false);
    }
    // I attach the handlers for the initiating drag event on the window.
    setupWindowEvents() {
        // NOTE: Since we are attaching the initiating event-handler OUTSIDE of the
        // Angular Zone, it means that any event-handlers that we bind in response to the
        // following event will ALSO be bound OUTSIDE of the Angular Zone. This is why we
        // only need to use this approach once.
        this.zone.runOutsideAngular(() => {
            window.addEventListener('dragover', this.handleWindowDragOver, false);
        });
    }
    // I determine if the application should respond to the given initiating drag event.
    // --
    // NOTE: In reality, this can't be done effectively in a cross-browser way since not
    // all browsers have access to the File objects, mid-drag. As such, in a real app, I
    // would always response to the drag event and then validate the file on drop.
    shouldRespondToDragEvent(event) {
        var fileType = this.getFileTypeFromDragEvent(event);
        // CAUTION: Since not all browsers (ex, Safari and Internet Explorer) can access
        // the file meta-data during the DRAG operation, we have to assume that if the
        // DRAG event doesn't contain any accessible items or files, it may still have
        // items in the subsequent DROP event.
        if (!fileType) {
            return (true);
        }
        return (this.isTextMimeType(fileType));
    }
    // I detach the handlers for the drop zone events.
    teardownDragShieldEvents() {
        this.dragShieldRef.nativeElement.removeEventListener('dragover', this.handleShieldDragOver, false);
        this.dragShieldRef.nativeElement.removeEventListener('dragleave', this.handleShieldDragLeave, false);
        this.dragShieldRef.nativeElement.removeEventListener('drop', this.handleShieldDrop, false);
    }
    // I detach the handlers for the initiating window drag events.
    teardownWindowEvents() {
        window.removeEventListener('dragover', this.handleWindowDragOver, false);
    }
};
MyFileDropComponent.ctorParameters = () => [
    { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ElementRef"] },
    { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["NgZone"] }
];
MyFileDropComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: "my-file-drop",
        outputs: ['textDropEvents: textDrop'],
        host: {
            '[class.active]': 'isActive'
        },
        queries: {
            'dragShieldRef': new _angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewChild"]('dragShieldRef', { static: false })
        },
        template: `
		<div #dragShieldRef class="drag-shield">
			<!--
				Drag-and-Drop events are notoriously hard to work with. So, instead of
				trying to be clever, I'm just going to side-step the whole issue by
				creating a "shield" that sits above (zIndex) the rest of the elements
				and has no children. This way the "leave" event is easy to reason about
				since it doesn't have to deal with bubbling-up events.
			-->
		</div>

		<span class="call-to-action">
			<ng-content></ng-content>
		</span>
	`,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./my-file-drop.component.css */ "./src/app/my-file-drop/my-file-drop.component.css")).default]
    })
], MyFileDropComponent);



/***/ }),

/***/ "./src/app/toolbar/toolbar.component.css":
/*!***********************************************!*\
  !*** ./src/app/toolbar/toolbar.component.css ***!
  \***********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL3Rvb2xiYXIvdG9vbGJhci5jb21wb25lbnQuY3NzIn0= */");

/***/ }),

/***/ "./src/app/toolbar/toolbar.component.ts":
/*!**********************************************!*\
  !*** ./src/app/toolbar/toolbar.component.ts ***!
  \**********************************************/
/*! exports provided: ToolbarComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ToolbarComponent", function() { return ToolbarComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let ToolbarComponent = class ToolbarComponent {
    constructor() {
        this.onFileSelected = new _angular_core__WEBPACK_IMPORTED_MODULE_1__["EventEmitter"]();
        this.onMultipleFileSelected = new _angular_core__WEBPACK_IMPORTED_MODULE_1__["EventEmitter"]();
        this.singleLogViewer = false;
        this.files = [];
    }
    ngOnInit() {
    }
    fileChanged(e) {
        this.file = e.target.files[0];
        console.log(this.file);
        this.uploadDocument(this.file);
    }
    uploadDocument(file) {
        var reader = new FileReader();
        reader.onload = () => {
            console.log(reader.result);
            this.onFileSelected.emit(reader.result);
        };
        reader.readAsText(file);
    }
    fileChangedMultiple(event) {
        console.log(event);
        if (event.target.files.length) {
            for (let i = 0; i < event.target.files.length; i++) {
                this.files.push(event.target.files[i]);
            }
        }
        for (let index = 0; index < this.files.length; index++) {
            const file = this.files[index];
            //console.log(file);
            //this.readFile(file);
        }
        this.onMultipleFileSelected.emit(this.files);
        //console.log(this.files);
    }
    readFile(file) {
        var reader = new FileReader();
        reader.onload = () => {
            console.log(reader.result);
        };
        reader.readAsText(file);
    }
};
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Output"])()
], ToolbarComponent.prototype, "onFileSelected", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Output"])()
], ToolbarComponent.prototype, "onMultipleFileSelected", void 0);
ToolbarComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-toolbar',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./toolbar.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/toolbar/toolbar.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./toolbar.component.css */ "./src/app/toolbar/toolbar.component.css")).default]
    })
], ToolbarComponent);



/***/ }),

/***/ "./src/environments/environment.ts":
/*!*****************************************!*\
  !*** ./src/environments/environment.ts ***!
  \*****************************************/
/*! exports provided: environment */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "environment", function() { return environment; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

const environment = {
    production: false
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.


/***/ }),

/***/ "./src/main.ts":
/*!*********************!*\
  !*** ./src/main.ts ***!
  \*********************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var hammerjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! hammerjs */ "./node_modules/hammerjs/hammer.js");
/* harmony import */ var hammerjs__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(hammerjs__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_platform_browser_dynamic__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/platform-browser-dynamic */ "./node_modules/@angular/platform-browser-dynamic/fesm2015/platform-browser-dynamic.js");
/* harmony import */ var _app_app_module__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./app/app.module */ "./src/app/app.module.ts");
/* harmony import */ var _environments_environment__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./environments/environment */ "./src/environments/environment.ts");






if (_environments_environment__WEBPACK_IMPORTED_MODULE_5__["environment"].production) {
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["enableProdMode"])();
}
Object(_angular_platform_browser_dynamic__WEBPACK_IMPORTED_MODULE_3__["platformBrowserDynamic"])().bootstrapModule(_app_app_module__WEBPACK_IMPORTED_MODULE_4__["AppModule"])
    .catch(err => console.error(err));


/***/ }),

/***/ 0:
/*!***************************!*\
  !*** multi ./src/main.ts ***!
  \***************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(/*! /builds/ponnusamyducont/nurserosielogviewer/src/main.ts */"./src/main.ts");


/***/ })

},[[0,"runtime","vendor"]]]);
//# sourceMappingURL=main-es2015.js.map